export default function Testimonials() {
  const testimonials = [
    {
      name: 'Peter Parker',
      role: 'Real Estate Agent',
      content: 'Mike has done a great job for my clients in every aspect of home remodeling and repairs, from making wet crawlspaces clean and dry to deck rebuilding to permitted additions to elevator installation. Mike\'s very capable, does outstanding work at a fair price and is great to work with.',
      rating: 5
    },
    {
      name: 'Michel Phillips',
      role: 'Client',
      content: 'Mike kept me informed during the entire process, dealt with me patiently as I panicked along the way, the project cost what I expected and was performed professionally. I\'d work with him again in a minute and would trust any tradespeople he recommended.',
      rating: 5
    },
    {
      name: 'Cheryl Louis',
      role: 'Client',
      content: 'I highly recommend R & R Contracting. Mike Reed did a wonderful job on our very complicated project. Mike was professional, prompt and easy to communicate with. Mike worked flawlessly with his subcontractors and everything was done on time.',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            What Our <span className="text-teal-600">Clients Say</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Don't just take our word for it - hear from satisfied customers across Grass Valley
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-100 hover:-translate-y-1"
            >
              {/* Stars */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              {/* Quote Icon */}
              <div className="mb-4">
                <i className="ri-double-quotes-l text-4xl text-teal-600/20"></i>
              </div>

              {/* Content */}
              <p className="text-sm text-slate-700 leading-relaxed mb-6">
                {testimonial.content}
              </p>

              {/* Author */}
              <div className="flex items-center space-x-4 pt-4 border-t border-slate-100">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center shadow-md">
                  <span className="text-white font-bold text-lg">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="font-bold text-slate-900">{testimonial.name}</div>
                  <div className="text-sm text-slate-600">{testimonial.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-3 bg-white rounded-full px-8 py-4 shadow-lg border border-slate-100">
            <i className="ri-star-fill text-yellow-400 text-2xl"></i>
            <div className="text-left">
              <div className="text-2xl font-bold text-slate-900">A+ Rating</div>
              <div className="text-sm text-slate-600">Better Business Bureau</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
